import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useEditBlockedSlot = (handleClose: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();
  const { mutate: editBlockedSlot, isLoading: editBlockedSlotIsLoading } =
    trpc.editBlockedSlot.useMutation({
      onSuccess: () => {
        trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

        showSuccess(
          t('common.notification.success.message', {
            action: 'updated',
            entity: 'blocked slot',
          })
        );

        handleClose();
      },
      onError: () => {
        showError(
          t('common.notification.error.message', {
            action: 'update',
            entity: 'blocked slot',
          })
        );
        handleClose();
      },
    });

  return { editBlockedSlot, editBlockedSlotIsLoading };
};
